import { FC, ReactNode } from "react";
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
} from "@chakra-ui/react";
import { MobileNestedDrawerHeader } from "./MobileNestedDrawerHeader";

interface Props {
  btnRef: any;
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onCloseComplete: () => void;
}

export const MobileHeaderDrawer: FC<Props> = ({
  btnRef,
  children,
  isOpen,
  onClose,
  onCloseComplete,
}) => {
  return (
    <Drawer
      finalFocusRef={btnRef}
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={onCloseComplete}
      placement="left"
      size="full"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerHeader>
          <MobileNestedDrawerHeader />
        </DrawerHeader>
        <DrawerBody pt={4}>
          <Flex justify="center">
            <Flex direction="column" w="100%">
              {children}
            </Flex>
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
